module.exports = __webpack_public_path__ + "static/media/yugo-pin-big.5fcc60f6.svg";